import React, { Component } from "react";
import "./matrix_score_info.scss";
import EditNode from "../../../../../EditNode/edit_node";
import XmUpload from "../../../../../Upload_pic/xm_upload";
import cur_icon_circle_sel from "../../../../../../images/emotion_analysis/cur_icon_circle_sel.png";
import cur_icon_circle_nor from "../../../../../../images/emotion_analysis/cur_icon_circle_nor.png";
import cur_icon_delete from "../../../../../../images/cur_icon_delete.png";
import cur_icon_add from "../../../../../../images/cur_icon_add.png";

export default class matrix_score_info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "matrix_score_info", //从哪个页面进入的
      dataList: {},
      min_value: 0,
      max_value: 5,
      min_name: "",
      max_name: "",
    };
  }
  static getDerivedStateFromProps(props, state) {
    if (
      JSON.stringify(props.dataList) !== JSON.stringify(state.dataList_prev)
    ) {
      return {
        needRefresh: true,
        dataList: props.dataList || state.dataList,
        dataList_prev: props.dataList,
        min_value: parseInt(props.dataList.min_value),
        max_value: parseInt(props.dataList.max_value) || "",
        min_name: props.dataList.min_name || state.min_name,
        max_name: props.dataList.max_name || state.max_name,
      };
    }
    return null;
  }
  componentDidMount() {
    this._isMounted = true;
    // if (this._isMounted) {
    //     this.toInitChart()
    //     setTimeout(() => {
    //         this.toInitFoot()
    //     })
    // }
  }
  componentDidUpdate() {
    if (this._isMounted && this.state.needRefresh) {
      // this.toInitChart()
      // setTimeout(() => {
      //     this.toInitFoot()
      // })
      this.setState({
        needRefresh: false,
      });
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
    this.setState = () => {};
  }
  // 编辑选项
  onChangeEditor(option_index, obj) {
    this.props.handleQuestionOptionName(option_index, obj.value);
  }
  // 添加选项图片
  addOptionPic(option_index, image, filename) {
    this.props.addOptionPic(option_index, image, filename);
  }
  // 删除选项图片
  deleteOptionPic(option_index) {
    this.props.deleteOptionPic(option_index);
  }
  //添加选项
  handleAddOption() {
    this.props.handleAddOption();
  }
  // 删除选项
  handleDeleteOption(option_index) {
    this.props.handleDeleteOption(option_index);
  }
  // 选项上下架
  handleActiveOption(option_index) {
    this.props.handleActiveOption(option_index);
  }
  // 设置选项
  handleSetOption(option_index, e) {
    //如果提供了事件对象，则这是一个非IE浏览器
    if (e && e.stopPropagation) {
      //因此它支持W3C的stopPropagation()方法
      e.stopPropagation();
    } else {
      //否则，我们需要使用IE的方式来取消事件冒泡
      window.event.cancelBubble = true;
    }

    this.props.handleSetOption(option_index);
  }
  render() {
    let items = [];

    for (let i = this.state.min_value; i <= this.state.max_value; i++) {
      if (i === this.state.min_value) {
        items.push(
          <div className="grade-item" key={i}>
            <img src={cur_icon_circle_sel} alt="" />
            {/* <span>{i}</span> */}
          </div>
        );
      } else {
        items.push(
          <div className="grade-item" key={i}>
            <img src={cur_icon_circle_nor} alt="" />
            {/* <span>{i}</span>  */}
          </div>
        );
      }
    }
    let val_items = [];
    for (let i = this.state.min_value; i <= this.state.max_value; i++) {
      val_items.push(
        <div className="grade-item" key={i}>
          <span>{i}</span>
        </div>
      );
    }
    return (
      <div className="matrix-score-info-container">
        <div className="matrix-score-info-top">
          <div className="info-top-name-wrap">
            <div className="info-top-name">{this.state.min_name}</div>
            <div className="info-top-name">{this.state.max_name}</div>
          </div>
          <div className="info-top-value-wrap">{val_items}</div>
        </div>
        <div className="matrix-score-info-answer">
          {this.state.dataList.answers.map((item, index) => {
            return (
              <div
                className={`draw-slip ${
                  item.is_option_active === 1 ? "" : "draw-slip-2"
                } ${
                  index === this.props.currentOptionIndex
                    ? "draw-slip-setting"
                    : ""
                }`}
                key={index}
              >
                <div className="draw-slip-left draw-slip-left-border">
                  <div className="draw-slip-title">
                    <div className="edit-question-title-wrap">
                      <EditNode
                        isEdit={true}
                        value={item.name}
                        onChange={this.onChangeEditor.bind(this, index)}
                        className="edit-question-title"
                      ></EditNode>
                    </div>
                    <div>
                      <XmUpload
                        className="upload-question-pic"
                        image_name={item.image.val}
                        handleDeletePic={this.deleteOptionPic.bind(this, index)}
                        handleUploadPic={this.addOptionPic.bind(this, index)}
                      ></XmUpload>
                    </div>
                  </div>
                  <div className="draw-slip-index">{items}</div>
                </div>
                <div className="draw-slip-right">
                  <img
                    src={cur_icon_delete}
                    className="delete-option-icon"
                    alt=""
                    onClick={this.handleDeleteOption.bind(this, index)}
                  />
                  {
                    <div
                      className="option-active-wrapper"
                      onClick={this.handleSetOption.bind(this, index)}
                    >
                      {<div>设置</div>}
                    </div>
                  }
                </div>
              </div>
            );
          })}
        </div>
        <div className="info-foot" onClick={this.handleAddOption.bind(this)}>
          <img src={cur_icon_add} className="add-option-icon" alt="" />
          <div>添加选项</div>
        </div>
      </div>
    );
  }
}
